import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Zap, Info, Moon, Sun } from "lucide-react";
import ToolsNav from "@/components/ToolsNav";
import QuickConvert from "@/components/QuickConvert";

export default function Header({ darkMode, onToggleDarkMode }) {
  return (
    <header className="border-b border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-800/70 backdrop-blur-md sticky top-0 z-50 transition-colors duration-300">
      <div className="container mx-auto px-4 py-4 md:py-6">
        <div className="flex items-center justify-between">
          <a href="https://kaytool.com" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center">
              <Zap className="w-5 h-5 text-white" />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-900 dark:text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
              KayTool
            </h1>
          </a>
          <div className="flex items-center gap-3">
            <QuickConvert />
            <ToolsNav />
            <Badge variant="secondary" className="hidden md:flex items-center gap-1 px-3 py-1 dark:bg-slate-700 dark:text-slate-200">
              <Info className="w-3 h-3" />
              100% Local Processing
            </Badge>
            <Button
              data-testid="dark-mode-toggle"
              variant="outline"
              size="icon"
              onClick={onToggleDarkMode}
              className="rounded-full w-10 h-10 border-slate-200 dark:border-slate-600 dark:bg-slate-700 dark:hover:bg-slate-600 transition-colors duration-300"
            >
              {darkMode ? (
                <Sun className="w-5 h-5 text-yellow-500" />
              ) : (
                <Moon className="w-5 h-5 text-slate-600" />
              )}
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
